import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { XlsxImportDeviceFaultPayload } from 'api/actions/xlsx-import-device-fault/xlsx-import-device-fault-payload';
import { XlsxImportDeviceFaultPathParameters } from 'api/actions/xlsx-import-device-fault/xlsx-import-device-fault-path-parameters';
import { XlsxImportDeviceFaultResponse } from 'api/actions/xlsx-import-device-fault/xlsx-import-device-fault-response';

type XlsxImportDeviceFaultQueryParameters = Record<string, any>;

/**
 * The path of the XlsxImportDeviceFault action.
 */
export const xlsxImportDeviceFaultActionPath = new SweetPath<keyof XlsxImportDeviceFaultPathParameters>(
  '/api/xlsx/import-device-fault',
  { path: '{param}' }
);

/**
 * Creates a contextualized XlsxImportDeviceFault actions.
 */
export default function createXlsxImportDeviceFaultAction(axios: AxiosInstance) {
  return function xlsxImportDeviceFaultAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: XlsxImportDeviceFaultQueryParameters;
    payload: XlsxImportDeviceFaultPayload;
  }) {
    const path = xlsxImportDeviceFaultActionPath.original;

    return axios.request<XlsxImportDeviceFaultResponse, XlsxImportDeviceFaultResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
